import axios from 'axios';
import { axiosETAGCache } from 'axios-etag-cache';

const axiosWithETAGCache = axiosETAGCache(axios);
let globalCustomMetricSchema = null;

const api = {
  async computeMetrics(chart, filter) {
    const response = await axiosWithETAGCache.post(`/compute_metrics`, {
      chart,
      filter,
    });
    return response.data;
  },
  async getCustomMetricSchema() {
    if (globalCustomMetricSchema) {
      return globalCustomMetricSchema;
    }
    const response = await axiosWithETAGCache.get(`/custom_metric/schema`);
    globalCustomMetricSchema = response.data;
    return response.data;
  },
  async getCustomMetrics(tableQuery) {
    const queryParams = {
      query: JSON.stringify(tableQuery),
    };

    const response = await axiosWithETAGCache.get(`/custom_metric`, {
      params: queryParams,
    });

    return response.data;
  },
  async createNewCustomMetric(newCustomMetricData) {
    const response = await axios.post(`/custom_metric`, newCustomMetricData);

    return response.data;
  },
  async getCustomMetric(customMetricId) {
    const queryParams = {};

    const response = await axiosWithETAGCache.get(
      `/custom_metric/${customMetricId}`,
      {
        params: queryParams,
      }
    );

    return response.data;
  },
  async saveCustomMetric(customMetric) {
    const response = await axios.put(
      `/custom_metric/${customMetric.id}`,
      customMetric
    );
    return response.data;
  },
  async deleteCustomMetric(customMetricId) {
    const response = await axios.delete(`/custom_metric/${customMetricId}`);

    return response.data;
  },
};

export default api;
